<template>
  <div class="page-wrap">
    <Header></Header>

    <div class="apply-area flex-r-center">
      <div class="card-width">
        <el-card >
          <div slot="header" class="card-wrap flex-center-center fz24">
            <div
                class="tab-item tab-item-active"
            >
              物理印章备案
            </div>
          </div>

          <div class="single-apply-area">
            <el-empty description="支付成功" :image="require('@/assets/pay-success.png')"></el-empty>
          </div>

          <div>
            <el-button class="next-button" style="margin-top: 0" type="primary" @click="handleContinue()">继续申领</el-button>
          </div>

        </el-card>
      </div>
    </div>

    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import Cookies from "js-cookie";
export default {
  name: "paySuccess",
  components: {Bottom, Header},
  created() {
    this.PhysicalSeal = Cookies.get('PhysicalSeal')
  },
  data() {
    return {
      PhysicalSeal: null,
    }
  },
  methods: {
    handleContinue(){
      if (this.PhysicalSeal){
        this.$http.post(this.$api.H5.recreateApply).then(res => {
          if (res.data.code == 200){
            if (res.data.data.applyId){
              this.$router.replace({
                path: "/register/physicsSeal/" + res.data.data.applyId,
              });
            }else {
              this.$router.replace({
                path: "/register/operatorAuthentication",
              });
            }
          }else {
            this.$message.error(res.data.msg)
          }
        })
      }else {
        this.$router.replace({
          path: "/register/operatorAuthentication",
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.single-apply-area {
  margin-left: 112px;
  margin-right: 112px;
  height: 500px;
  display: flex;
  align-content: center;
  justify-content: center;
  .upload-image {
    display: flex;
    align-items: flex-start;
    .top-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
    }
  }
  .captcha-item {
    position: relative;
  }
  .get-cap {
    position: absolute;
    right: 20px;
    top: 0px;
    color: #407fff;
    cursor: pointer;
  }
  .next-button {
    width: 350px;
    font-size: 16px;
    padding: 11px 20px !important;
    margin-top: 40px;
    box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
  }
}
</style>
